/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './spec-vital-result.reducer';

export const SpecVitalResultDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const specVitalResultEntity = useAppSelector(state => state.specVitalResult.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="specVitalResultDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.specVitalResult.detail.title">SpecVitalResult</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.id">Id</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.id}</dd>
          <dt>
            <span id="observation">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.observation">Observation</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.observation}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.comments}</dd>
          <dt>
            <span id="eventId">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.eventId">Event Id</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.eventId}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.modifiedByType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.active">Active</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.timestampEntry}</dd>
          <dt>
            <span id="EventType">
              <Translate contentKey="tinyMedicRestApp.specVitalResult.EventType">Event Type</Translate>
            </span>
          </dt>
          <dd>{specVitalResultEntity.EventType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specVitalResult.specVital">Spec Vital</Translate>
          </dt>
          <dd>{specVitalResultEntity.specVital ? specVitalResultEntity.specVital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specVitalResult.patient">Patient</Translate>
          </dt>
          <dd>{specVitalResultEntity.patient ? specVitalResultEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/spec-vital-result" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/spec-vital-result/${specVitalResultEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SpecVitalResultDetail;
